import { render, staticRenderFns } from "./checkout_basic.vue?vue&type=template&id=c49a6b7e&"
import script from "./checkout_basic.vue?vue&type=script&lang=js&"
export * from "./checkout_basic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports